export const REQUEST_EDITUSERDATA = 'REQUEST_EDITUSERDATA';
export const EDITUSERDATA_RECEIVED = 'EDITUSERDATA_RECEIVED';

